import { useSelector } from "react-redux";
import flow from "lodash/fp/flow";
import filter from "lodash/fp/filter";
import castArray from "lodash/fp/castArray";
import head from "lodash/fp/head";

import { shouldBeDisplayed } from "utils";
import { selectUserChoiceValues } from "store/app";

import ColorPickerToolTip from "components/ColorPickerToolTip";
import ImageToolTip from "components/ImageToolTip";
import TextToolTip from "components/TextToolTip";

export default function ToolTipSelector({ component, props: unfilteredProps }) {
  const userChoiceValues = useSelector(selectUserChoiceValues);

  const props = flow(
    castArray,
    filter(shouldBeDisplayed(userChoiceValues)),
    head
  )(unfilteredProps);

  switch (component) {
    case "ColorPickerToolTip":
      return (
        <ColorPickerToolTip backgroundColor={props?.backgroundColor}>
          {props?.label}
        </ColorPickerToolTip>
      );

    case "ImageToolTip":
      return (
        <ImageToolTip
          labelImage={props?.labelImage}
          image={props?.image}
          imageWidth={props?.imageWidth}
          imageHeight={props?.imageHeight}
          backgroundColor={props?.backgroundColor}
          dangerouslySetLabel={props.label_HTML}
        >
          {props?.label}
        </ImageToolTip>
      );

    default:
      return (
        <TextToolTip dangerouslySetLabel={props.label_HTML}>
          {props?.label}
        </TextToolTip>
      );
  }
}
